import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Search = () => (
    <SingePathIcon path="M13.7627 2.22732C17.0247 4.91127 17.716 9.63324 15.3603 13.1397L18.4628 16.2421C19.08 16.8594 19.08 17.8601 18.4628 18.4773C17.8456 19.0946 16.8448 19.0946 16.2276 18.4773L13.1251 15.3749C9.61874 17.7306 4.89679 17.0393 2.21283 13.7773C-0.471136 10.5153 -0.239992 5.74858 2.74699 2.76157C5.73398 -0.225449 10.5007 -0.456625 13.7627 2.22732ZM2.2549 8.571C2.2549 12.0513 5.07624 14.8727 8.55655 14.8727C12.0352 14.8688 14.8543 12.0497 14.8582 8.57102C14.8582 5.09069 12.0369 2.26933 8.55659 2.26932C5.07627 2.26932 2.25491 5.09067 2.2549 8.571Z" />
);

Search.viewBox = `0 0 19 19`;
